import React from 'react';

import TotalsListItem, { IItemProps } from './TotalsListItem/TotalsListItem';
import Styles from './styles.module.scss';
import { PermissionsUI } from '../../Permissions/PermissionsUI';
import { ReactComponent as StatsIcon } from '../../../assets/images/total-stats-perm.svg';

export interface ITotalsListWidget {
    items: IItemProps[];
    title?: JSX.Element | string;
    loading?: boolean;
    allVenues?: boolean;
    hasPermission?: boolean;
}

const TotalsListWidget = (props: ITotalsListWidget) => {
    const { hasPermission = true } = props;
    return (
        <div>
            <div className={Styles.Header}>{props.title}</div>
            {hasPermission ? (
                <ul className={Styles.List}>
                    {props.items.map((item) => (
                        <li className={Styles.Item} key={item.label}>
                            <TotalsListItem {...item} loading={props.loading} allVenues={props.allVenues} />
                        </li>
                    ))}
                </ul>
            ) : (
                <PermissionsUI icon={<StatsIcon />} />
            )}
        </div>
    );
};

export default TotalsListWidget;
